<template>
  <div class="login-container">
    <div class="login-box">
      <div class="login-header">
        <img src="@/assets/logo.png" alt="Logo" class="logo" />
        <h1>管理员登录</h1>
      </div>
      
      <a-form
        :model="formState"
        name="loginForm"
        class="login-form"
        @finish="onFinish"
      >
        <a-form-item
          name="username"
          :rules="[{ required: true, message: '请输入用户名' }]"
        >
          <a-input
            v-model:value="formState.username"
            placeholder="用户名"
            size="large"
          >
            <template #prefix>
              <user-outlined />
            </template>
          </a-input>
        </a-form-item>

        <a-form-item
          name="password"
          :rules="[{ required: true, message: '请输入密码' }]"
        >
          <a-input-password
            v-model:value="formState.password"
            placeholder="密码"
            size="large"
          >
            <template #prefix>
              <lock-outlined />
            </template>
          </a-input-password>
        </a-form-item>

        <a-form-item>
          <a-checkbox v-model:checked="formState.remember">
            记住我
          </a-checkbox>
          <a class="forgot-link">忘记密码？</a>
        </a-form-item>

        <a-form-item>
          <a-button
            type="primary"
            html-type="submit"
            class="login-button"
            size="large"
            :loading="loading"
          >
            登录
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref } from 'vue'
import { UserOutlined, LockOutlined } from '@ant-design/icons-vue'
import { useRouter } from 'vue-router'
import axios from 'axios'
import { message } from 'ant-design-vue'
import { getApiUrl } from '@/utils/api'

export default defineComponent({
  name: 'LoginView',
  components: {
    UserOutlined,
    LockOutlined
  },
  setup() {
    const router = useRouter()
    const loading = ref(false)
    const formState = reactive({
      username: '',
      password: '',
      remember: true
    })

    const onFinish = async (values) => {
      try {
        loading.value = true
        const loginUrl = getApiUrl('/api/auth/login');
        console.log('登录请求URL:', loginUrl); // 打印实际使用的登录URL
        
        const response = await axios.post(loginUrl, {
          username: values.username,
          password: values.password
        })

        if (response.data.isLoggedIn) {
          // 保存登录状态
          localStorage.setItem('isLoggedIn', 'true')
          if (formState.remember) {
            localStorage.setItem('username', values.username)
          }
          message.success('登录成功')
          // 延迟跳转，让用户看到成功提示
          setTimeout(() => {
            // 如果有重定向地址，就跳转到重定向地址
            const redirect = router.currentRoute.value.query.redirect
            router.push(redirect || '/admin')
          }, 1000)
        }
      } catch (error) {
        message.error('登录失败：' + (error.response?.data?.message || '请检查用户名和密码'))
      } finally {
        loading.value = false
      }
    }

    return {
      formState,
      loading,
      onFinish
    }
  }
})
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1a1a1a 0%, #0a0a0a 100%);
  padding: 20px;
}

.login-box {
  width: 100%;
  max-width: 400px;
  padding: 40px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.logo {
  width: 80px;
  height: 80px;
  margin-bottom: 16px;
}

.login-header h1 {
  color: #fff;
  font-size: 24px;
  font-weight: 300;
  margin: 0;
}

.login-form {
  width: 100%;
}

:deep(.ant-input-affix-wrapper) {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  color: #fff !important;
}

:deep(.ant-input) {
  background: transparent !important;
  color: #fff !important;
}

:deep(.ant-input-password-icon) {
  color: rgba(255, 255, 255, 0.45) !important;
}

:deep(.ant-checkbox-wrapper) {
  color: #fff;
}

.forgot-link {
  float: right;
  color: #1890ff;
}

.login-button {
  width: 100%;
  height: 40px;
  font-size: 16px;
  background: #1890ff;
  border: none;
}

:deep(.anticon) {
  color: rgba(255, 255, 255, 0.45);
}

@media (max-width: 480px) {
  .login-box {
    padding: 30px 20px;
  }
}
</style> 